import { version } from '../../package.json';

export const environment = {
  version: version,
  config: '/assets/config/config.json', // path to config file
  module: 'pieces', // * le module
  production: true, // * indicateur de production pour angular
};
